import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars
} from "../contentful/graphql";
import { init as initRelay } from "../init-relay";
import { StrategyCollectionPricingPage } from "../pages/collections/strategy/pricing/strategy-collection-pricing-page";

initRelay(
    StrategyCollectionPricingPage,
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars("strategy-collection", window.location),
    RELAY_API_CONTENTFUL
);
